import MuiButton from './MuiButton';
import MuiPaper from './MuiPaper';

export default {
  MuiButton,
  MuiPaper,
};